import { render, staticRenderFns } from "./FeaturesCentered.vue?vue&type=template&id=484f09f1&scoped=true&"
import script from "./FeaturesCentered.vue?vue&type=script&lang=js&"
export * from "./FeaturesCentered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484f09f1",
  null
  
)

export default component.exports